import { useEffect, useState } from "react";
import { PlayCircle } from "lucide-react";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function DemoLogins() {
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(null);
  const { signIn } = useAuth();
  const nav = useNavigate();
  useEffect(() => { api.get("/auth/public/demo-accounts").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d?.accounts?.length) return null;
  const go = async (a) => {
    setBusy(a.email);
    try {
      const r = await api.post("/auth/login", { email: a.email, password: d.password });
      await signIn(r.data);
      nav("/dashboard");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(null); }
  };
  return (
    <div className="mt-10 w-full min-w-0 overflow-hidden rounded-xl border border-amber-500/40 bg-amber-50/60 p-4" data-testid="demo-logins">
      <div className="flex items-center justify-between gap-2 mb-1">
        <div className="font-semibold text-sm">Demo Login</div>
        <span className="lx-mock-badge" data-testid="demo-logins-badge">DEMO DATA</span>
      </div>
      <p className="text-xs text-slate-500 mb-3">Explore with sample projects and data. Real payments, live campaigns, publishing and external transactions are disabled. Password for all: <b className="font-mono" data-testid="demo-password">{d.password}</b></p>
      <div className="space-y-2">
        {d.accounts.map((a) => (
          <div key={a.email} className="flex items-center justify-between gap-2 rounded-lg border border-slate-800 bg-white px-3 py-2" data-testid={`demo-login-${a.account_type}`}>
            <div className="min-w-0">
              <div className="text-sm font-semibold">{a.label}</div>
              <div className="text-[11px] text-slate-500 truncate font-mono">{a.email}</div>
              <div className="text-[11px] text-slate-500 truncate">{a.workspace}</div>
            </div>
            <button type="button" onClick={() => go(a)} disabled={!!busy} className="shrink-0 inline-flex items-center gap-1 px-3 py-1.5 rounded-full bg-emerald-600 text-white text-xs font-semibold hover:bg-emerald-700 disabled:opacity-50" data-testid={`demo-login-btn-${a.account_type}`}>
              <PlayCircle className="h-3.5 w-3.5" />{busy === a.email ? "Opening..." : "Try demo"}
            </button>
          </div>))}
      </div>
    </div>
  );
}
